import { ref } from "vue";
import { extractItems } from "@/shared/serviceResponse";
import {
  getApplicationParticipants,
  addApplicationParticipant,
  updateApplicationParticipant,
  deleteApplicationParticipant,
} from "../api";

export function useApplicationParticipants(uuid) {
  const participants = ref([]);
  const participantsLoading = ref(false);

  async function fetchParticipants() {
    if (!uuid?.value) return;
    participantsLoading.value = true;
    try {
      const response = await getApplicationParticipants(uuid.value);
      if (response?.success) {
        participants.value = extractItems(response?.payload);
      }
    } catch (e) {
      console.error("fetchParticipants error:", e);
    } finally {
      participantsLoading.value = false;
    }
  }

  async function addParticipant(payload) {
    if (!uuid?.value) return null;
    const data = await addApplicationParticipant(uuid.value, payload);
    if (data?.success) {
      await fetchParticipants();
    }
    return data;
  }

  async function updateParticipant(participantUuid, payload) {
    if (!uuid?.value) return null;
    const data = await updateApplicationParticipant(
      uuid.value,
      participantUuid,
      payload
    );
    if (data?.success) {
      await fetchParticipants();
    }
    return data;
  }

  async function removeParticipant(participantUuid) {
    if (!uuid?.value) return null;
    const data = await deleteApplicationParticipant(
      uuid.value,
      participantUuid
    );
    if (data?.success) {
      await fetchParticipants();
    }
    return data;
  }

  return {
    participants,
    participantsLoading,
    fetchParticipants,
    addParticipant,
    updateParticipant,
    removeParticipant,
  };
}
